import classNames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './TutorialProgress.module.scss';

const propTypes = {
  at: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

const TutorialProgress = ({ at, total }) => (
  <div className={styles.dots}>
    {_.range(total).map((index) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className={classNames(styles.dot, {
          [styles.active]: index === at,
        })}
      />
    ))}
  </div>
);

TutorialProgress.propTypes = propTypes;

export default TutorialProgress;
